import React from "react";
import Link from "gatsby-link";
import ClassNames from "classnames";
import RenderHtml from "../utils/render-html";

import IngredientsModal from "../components/ingredients/modal"
import Bus from "../utils/bus";
let BUS = new Bus();

class Intro extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let ingredients = this.props.ingredients;
    return (
      <div className="Ingredients2-outer">
        <div className="IngredientsIntro">
          <h2>{this.props.ingredientsTitle}</h2>
          <p dangerouslySetInnerHTML={{ __html: this.props.ingredientsSubtext.replace(/\n/g,"<br />") }}></p>
        </div>
        <div className="Ingredients2">
          <h2>{this.props.ingredientsPretitle}</h2>
          <div className="items">
              {ingredients.map(({ node }, i) => {
                return (
                  <div id={node.name.replace(/\W+/g, '-').toLowerCase()} className="item" key={i}>
                    <div className="info">
                      <div className="internal">
                        <h3>{node.name}</h3>
                        <h4>{node.subName}</h4>
                        <div className="image-mobile">
                          <img src={node.image.fluid.src} />
                        </div>
                        <div
                          className="description"
                          dangerouslySetInnerHTML={RenderHtml.go(
                            node.description.replace(/\n/g,"<br />")
                          )}
                        />
                      </div>
                    </div>
                    <div className="image">
                      <img src={node.image.fluid.src} />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <IngredientsModal />
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/home/ingredients.js